import Highcharts, { Options } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, { VFC } from 'react';

const options: Options = {
  colors: [
    `#72C9EB`,
    `#1cabe2`,
    `#80bd41`,
    `#ffc20e`,
    `#f26a21`,
    `#e2231a`,
    `#961a49`,
  ],
  chart: {
    plotShadow: false,
    type: `pie`,
    height: `500px`,
  },
  tooltip: {
    pointFormat: `{series.name} <br>{point.percentage:.1f}%</br>`,
    style: {
      fontWeight: `bold`,
      fontFamily: `'Noto Sans KR',sans-serif`,
    },
  },
  accessibility: {
    point: {
      valueSuffix: `%`,
    },
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: `pointer`,
      dataLabels: {
        style: {
          fontSize: `18px`,
          fontWeight: `lighter`,
          color: `#fff`,
          textOutline: `false`,
          fontFamily: `'Noto Sans KR',sans-serif`,
        },
        enabled: true,
        format: `{point.y:.1f} %`,
        distance: -40,
        filter: {
          property: `percentage`,
          operator: `>`,
          value: 8,
        },
      },
    },
  },
  credits: {
    enabled: false,
  },
};

const DonutChartMobile: VFC<
  Pick<Options, 'series'> & { titleText: string }
> = ({ series, titleText }) => (
  <HighchartsReact
    highcharts={Highcharts}
    options={{
      ...options,
      series,
      title: {
        text: titleText,
        align: `left`,
        style: {
          fontSize: `16px`,
          transform: `translate(-10px, 0)`,
          fontFamily: `'Noto Sans KR',sans-serif`,
        },
      },
    }}
  />
);

export default DonutChartMobile;
